import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useSkillCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/course-skill', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['skill-list'] });
    }
  });
};

export const useSkillUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/course-skill/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['skill-list'] });
    }
  });
};

export const useSkillDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/course-skill/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['skill-list'] });
    }
  });
};

export const useCourseSkillCreate = useSkillCreate;
export const useCourseSkillUpdate = useSkillUpdate;
export const useCourseSkillDelete = useSkillDelete;
